import { STORAGE_REPOSITORY_TYPE, S3_COMPATIBLE_REPOSITORY_TYPE, STORAGE_REPOSITORY_TYPE_LABELS } from "../types";
const repositoryOptions = (supportedTypes) => {
  const s3CompatibleOptions = supportedTypes.includes(STORAGE_REPOSITORY_TYPE.S3) ? [
    { value: S3_COMPATIBLE_REPOSITORY_TYPE.OVH, label: STORAGE_REPOSITORY_TYPE_LABELS.ovh },
    { value: S3_COMPATIBLE_REPOSITORY_TYPE.SYSELEVEN, label: STORAGE_REPOSITORY_TYPE_LABELS.syseleven }
  ] : [];
  return [
    ...supportedTypes.map((type) => ({ value: type, label: STORAGE_REPOSITORY_TYPE_LABELS[type] })),
    ...s3CompatibleOptions
  ];
};
export default repositoryOptions;
